import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Seule langue embarquée dans le bundle principal (langue de repli)
import fr from './locales/fr/translation.json';

const SUPPORTED = [
  'fr','en','de','es','it','uk','hu','pt','sv','nl','fi','pl','ro','el','no','da',
  'cs','sk','hr','lt','et','lv','bg','sl','sr','is','ar','mt'
];

const RTL_LANGUAGES = ['ar', 'he', 'fa', 'ur'];

// Backend minimal : charge un fichier de langue à la demande (un chunk par langue)
const lazyBackend = {
  type: 'backend',
  init() {},
  read(language, namespace, callback) {
    if (language === 'fr') return callback(null, fr);
    import(`./locales/${language}/translation.json`)
      .then((m) => callback(null, m.default || m))
      .catch((err) => callback(err, false));
  },
};

i18n
  .use(lazyBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { fr: { translation: fr } },
    partialBundledLanguages: true,   // fr est embarqué, les autres passent par le backend
    supportedLngs: SUPPORTED,
    nonExplicitSupportedLngs: true,  // 'de-DE' est ramené à 'de'
    load: 'languageOnly',
    fallbackLng: 'fr',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },   // pas de Suspense requis autour des composants
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'cookie', 'path', 'subdomain'],
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (lang) => {
  const isRTL = RTL_LANGUAGES.includes(lang);
  document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
  document.documentElement.setAttribute('lang', lang);
});

export default i18n;